import { render, staticRenderFns } from "./restrictionAnchorMarketList.vue?vue&type=template&id=39cf018c&scoped=true&"
import script from "./restrictionAnchorMarketList.vue?vue&type=script&lang=js&"
export * from "./restrictionAnchorMarketList.vue?vue&type=script&lang=js&"
import style0 from "./restrictionAnchorMarketList.vue?vue&type=style&index=0&id=39cf018c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf018c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cf018c')) {
      api.createRecord('39cf018c', component.options)
    } else {
      api.reload('39cf018c', component.options)
    }
    module.hot.accept("./restrictionAnchorMarketList.vue?vue&type=template&id=39cf018c&scoped=true&", function () {
      api.rerender('39cf018c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/anchorMarketConfiguration/restrictionAnchorMarketList.vue"
export default component.exports